module.exports = "https://web-assets.ifttt.com/packs/media/marketing/do_android-835ab522.png";